/* Unit conversion helpers — EU/cm → US/inches. Return {primary, secondary} or "—". */
export function fmtHeight(cm) {
  if (!cm) return "—";
  const totalIn = cm / 2.54;
  const ft = Math.floor(totalIn / 12);
  const inches = Math.round(totalIn - ft * 12);
  const ftAdj = inches === 12 ? ft + 1 : ft;
  const inAdj = inches === 12 ? 0 : inches;
  return { primary: `${cm} cm`, secondary: `${ftAdj}′ ${inAdj}″` };
}

export function fmtCmIn(cm) {
  if (!cm) return "—";
  const inches = Math.round(cm / 2.54);
  return { primary: `${cm} cm`, secondary: `${inches} in` };
}

// EU → US women's shoe size (US ≈ EU − 30, the common agency book convention)
export function fmtShoe(eu) {
  if (!eu) return "—";
  const us = +(Number(eu) - 30).toFixed(1);
  return { primary: `EU ${eu}`, secondary: `US ${us}` };
}

export const specText = (v) => (v && typeof v === "object" ? v.primary : v || "—");
